// src/SuggestMatchesPanel.jsx
import React, { useState } from 'react';
import { matchTeachers } from './api';

export default function SuggestMatchesPanel({ studentId }) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await matchTeachers(studentId);
      setRows(res.data?.matches || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border rounded p-2">
      <div className="flex items-center justify-between mb-2">
        <div className="font-semibold">Suggested Teachers</div>
        <button onClick={load} className="bg-sky-600 text-white px-3 py-1 rounded text-sm" disabled={loading}>
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div>
      {!rows ? (
        <div className="text-sm text-slate-500">Click Refresh to fetch suggestions.</div>
      ) : rows.length === 0 ? (
        <div className="text-sm">No matches found.</div>
      ) : (
        <table className="w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-1 text-left">Teacher</th>
              <th className="border p-1">Score</th>
              <th className="border p-1">Miles</th>
              <th className="border p-1 text-left">Reasons</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.teacher_id}>
                <td className="border p-1">{r.teacher_name}</td>
                <td className="border p-1 text-center">{r.score}</td>
                <td className="border p-1 text-center">{r.miles ?? '-'}</td>
                <td className="border p-1">
                  <div className="flex flex-wrap gap-1">
                    {(r.reasons || []).slice(0,8).map((c,i) => (
                      <span key={i} className="bg-sky-100 text-sky-800 px-2 py-0.5 rounded text-xs">{c}</span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

